// src/sections/Services.js
import React from 'react';
import './Services.css';

const services = [
  {
    title: 'Warehousing',
    description: '400,000+ sq. ft. of modern, ISO/GDP certified warehousing.',
    icon: '🏢',
  },
  {
    title: 'Transportation',
    description: 'Pan-India fleet operations with cold-chain capabilities.',
    icon: '🚚',
  },
  {
    title: 'Cold Chain',
    description: 'Refrigerated & insulated logistics with real-time temperature monitoring.',
    icon: '❄️',
  },
//   {
//     title: 'Repackaging',
//     description: 'Specialized pharma & cosmetic repackaging in clean zones.',
//     icon: '📦',
//   },
];

export default function Services() {
  return (
    <div className="services-section" id="services">
      <h2>Our Services</h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
